import { createContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Joyride, { STATUS } from "react-joyride";

export const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  const steps = {
    "/agent-dashboard": [
      {
        target: ".bpo-training-types",
        content:
          "Explore training sessions tailored to BPO agents—learn to become a top producer or investor with our expert-led modules.",
        disableBeacon: true,
      },
      {
        target: ".bpo-dashboard-cards",
        content:
          "Track your earnings, monitor agent performance, and access quick links to Live and Premier Agent tools—all from your dashboard.",
        disableBeacon: true,
      },
      {
        target: ".join-bpo-homes-vidoe",
        content:
          "Watch the BPO Homes intro video to understand how we empower agents with tech, training, and deal flow.",
        disableBeacon: true,
      },
      {
        target: ".bpo-report-summary",
        content:
          "Get a snapshot of your BPO report activity—submitted, pending, and earnings. Stay on top of your valuation work.",
        disableBeacon: true,
      },
      {
        target: ".bpo-agent-reviews",
        content:
          "See how clients rate your performance. Use reviews to build credibility and improve your agent profile.",
        disableBeacon: true,
      },
      {
        target: ".agent-subscription",
        content:
          "See your current subscription and when it expires. You can upgrade your plan",
        disableBeacon: true,
      },
    ],
    "/bpo-report": [
      {
        target: ".stats-cards",
        content: "BPO Status Cards give an overview of all reports",
        disableBeacon: true,
      },
      {
        target: ".search-n-filters",
        content: "Perform report search and filtering",
        disableBeacon: true,
      },
      {
        target: ".reports",
        content: "View reports in both tabular and card views",
        disableBeacon: true,
      },
    ],
  };

  const handleCallback = ({ action, index, type, status }) => {
    if (type === "step:after") {
      if (stepIndex < steps[location.pathname]?.length)
        setStepIndex(index + (action === "prev" ? -1 : 1));
    } else if (status === STATUS.SKIPPED || type === "tour:end") {
      if (location.pathname !== "/bpo-report") {
        // Check if route isn't the last in the list of steps
        localStorage.setItem("activeTourRoute", "/bpo-report");
        navigate("/bpo-report", { replace: true });
      } else {
        setRun(false);
        localStorage.setItem("tourSkipped", "true");
        localStorage.removeItem("activeTourRoute");
      }
    }
  };

  const startTour = (startAt = 0) => {
    setStepIndex(startAt);
    setRun(true);
  };

  return (
    <TourContext.Provider
      value={{ run, stepIndex, setRun, setStepIndex, startTour }}
    >
      {children}

      <Joyride
        key={location.pathname}
        steps={steps[location.pathname] || []}
        stepIndex={stepIndex}
        run={run}
        continuous
        showSkipButton
        callback={handleCallback}
        styles={{ options: { zIndex: 10000 } }}
      />
    </TourContext.Provider>
  );
};
